import { render, staticRenderFns } from "./ResponsibleViewPage.vue?vue&type=template&id=3a29d75d&"
import script from "./ResponsibleViewPage.vue?vue&type=script&lang=js&"
export * from "./ResponsibleViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports